import React from 'react'

function DataNotAvailable({ title }) {
  return (
    <>
      <h3 className="u-marginTop0 u-marginBottom3gu">{title}</h3>
      <div className="Grid Grid--alignMiddle u-bgColorWhite u-paddingBottom0">
        <span className="alert-warning-legacy u-posAbsolute"></span>
        <div className="Content u-paddingLeft8gu u-size10of12 u-sm-sizeFill u-paddingBottom0">
          <p>Data is not yet available for this recently launched fund.</p>
        </div>
      </div>
    </>
  )
}

export default DataNotAvailable
